import axios from 'axios'
import laroute from '~/laroute'
import store from '~/store'
import { Mrp } from '~/_shared/models'

// State
export const state = {
  items: [],
  mrp: new Mrp(),
  pdf: undefined
}

// Getters
export const getters = {
  items: state => state.items,
  mrp: state => state.mrp,
  pdf: state => state.pdf
}

// Mutations
export const mutations = {
  ITEMS (state, data) {
    state.items = data
  },

  MRP (state, data) {
    state.mrp = Object.assign(new Mrp(), data)
  },

  PDF (state, data) {
    state.pdf = data
  }
}

// Actions
export const actions = {
  async fetchData ({ commit }, { filterData }) {
    await axios.get(laroute.route('get_mrp_data', { companyAbbr: store.getters['auth/company'], ...filterData }))
      .then(res => {
        commit('ITEMS', res.data.data.items)
        commit('MRP', res.data.data.headers)
      })
      .catch(error => {
        console.log(error)
      })
  },

  async generatePDF ({ commit }, { mrp, items, totals }) {
    const { data } = await axios.post(laroute.route('mrp-generate-pdf', { companyAbbr: store.getters['auth/company'] }), { mrp, items, totals }, { responseType: 'arraybuffer' })

    commit('PDF', data)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/mrp.js